import {Link} from "react-router-dom";

const MenuSimple = ()=>{
    return (
        <>
            {window.scroll(0,0)}
            <nav className="historias-nav">
                <Link to="/"> <p  className="brand">@</p> </Link>
            </nav>
        </>
    )
}

export default MenuSimple